// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3UhVp","label":"Labeled_label__3GfQL","divider":"Labeled_divider__rrb2f"};